import React from "react";
import PropTypes from "prop-types";
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Legend } from "recharts";
import formatData from "../../utils/formatStackedBarChartData";

export default function StackedBarChart(props) {
  const { chartData, colors } = props;
  const { metrics, data } = chartData;

  if (metrics === null || data === null) {
    return <p data-testid="no-data">No data to available to display bar chart.</p>;
  }

  if (!metrics.length || !data.length) {
    return null;
  }

  const formattedData = formatData(data, metrics);

  return (
    <ResponsiveContainer width="100%" height={300}>
      <BarChart data={formattedData}>
        <CartesianGrid vertical={false} stroke="#a0a0a0" />
        <XAxis dataKey="name" />
        <YAxis />
        {/* <Tooltip cursor={false} /> */}
        <Legend
          verticalAlign="top"
          align="left"
          iconType="rect"
          height={60}
          wrapperStyle={{ paddingLeft: 40 }}
        />
        {metrics.map((metric, index) => (
          <Bar key={metric} dataKey={metric} stackId="a" fill={colors[index % colors.length]} />
        ))}
      </BarChart>
    </ResponsiveContainer>
  );
}

StackedBarChart.propTypes = {
  chartData: PropTypes.shape({
    metrics: PropTypes.array.isRequired,
    data: PropTypes.array.isRequired
  }).isRequired,
  colors: PropTypes.array
};

StackedBarChart.defaultProps = {
  chartData: {
    metrics: [],
    data: []
  },
  colors: ["#4667d4", "#2651ac", "#95adf7"]
};
